module.exports = __webpack_public_path__ + "assets/filtered-1f5fc6.svg";